var _ = require('underscore');
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 if (data.show_label_before) { 
__p+='\n    <span class="label-region"></span>\n';
 } 
__p+='\n\n    <span class="input-region"></span>\n\n';
 if (data.show_label_after) { 
__p+='\n    <span class="label-region"></span>\n';
 } 
__p+='\n\n';
 if (data.show_confirmation || data.show_error || data.show_note) { 
__p+='\n    <span class="status-region"></span>\n';
 } 
__p+='\n';
return __p;
};
